import React from 'react'
import { Container, Row, Col, Button } from 'reactstrap'
import TopNavigation from '../../TopNavigation'
import withAppconfig from '../../AppContext'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import ProShopProductCard from '../../components/Shop/ProShopProductCard'
import { Typography, MenuItem, MenuList, ListItemText, Drawer, Grid, IconButton } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

const mapStateToProps = (state, props) => {
  const { firebase } = state
  const { proshopproducts, proshopcategories, proshopbrands } = firebase.ordered
  const products = proshopproducts ? proshopproducts.map((m) => { 
    const category = proshopcategories ? proshopcategories.find((c) => c.key === m.value.productcategory) : null
    const brand = proshopbrands ? proshopbrands.find((b) => b.key === m.value.brand) : null
    const poster = m.value.image ? m.value.image : (props.appconfig && props.appconfig.logos && props.appconfig.logos.length > 0 ? { url: props.appconfig.logos[0].value, sizes: [300] } : null)
    const variations =  m.value.variations ?m.value.variations.map((v, i) => {
      if (!v.varid) v.varid = i + 1
      return v
    }) : null
    const p = { id: m.key, ...m.value, categoryname: category ? category.value.displayName : null, brandname: brand ? brand.value.displayName : null, variations: variations ? variations : null }
    if (poster) p.poster = poster
    return p
  }) : []
  // return only categories which have products
  const categoriesWithProducts = proshopcategories ? proshopcategories.filter((c) => proshopproducts.find((p) => p.value.productcategory === c.key)) : []
  return {
    products,
    categories: categoriesWithProducts ? categoriesWithProducts.map((m) => { return { id: m.key, ...m.value } }) : [],
    brands: proshopbrands ? proshopbrands.map((m) => { return { id: m.key, ...m.value } }) : []
  }
}

const withProducts = compose(
  connect((state) => ({ auth: state.firebase.auth })),
  firebaseConnect((props) => [
    {
      path: 'shop/' + props.appconfig.accountkey + '/proshop/products',
      queryParams: ['orderByChild=displayName'],
      storeAs: 'proshopproducts',
    },
    {
      path: 'shop/' + props.appconfig.accountkey + '/proshop/categories',
      queryParams: ['orderByChild=displayName'],
      storeAs: 'proshopcategories',
    },
    {
      path: 'shop/' + props.appconfig.accountkey + '/proshop/brands',
      queryParams: ['orderByChild=displayName'],
      storeAs: 'proshopbrands',
    }
  ]),
  connect(mapStateToProps)
)

const CategoryFilter = ({ categories, selectedCategory, onSelectCategory, numberofproducts }) => {
  const showAll = numberofproducts < 20
  if (!showAll && !selectedCategory && categories && categories.length > 0) {
    onSelectCategory(categories[0].id)
  } 
  return (
    <MenuList style={{ display: 'flex', flexDirection: 'row', paddingLeft: 0 }}>
      {showAll &&
        <MenuItem onClick={() => onSelectCategory(null)} selected={selectedCategory === null}>
          <ListItemText primary={'Kaikki'} />
        </MenuItem>
      }
      {categories.map((c, i) => (
        <MenuItem key={c.id} onClick={() => onSelectCategory(c.id)} selected={selectedCategory === c.id}>
          <ListItemText primary={c.displayName} />
        </MenuItem>
      ))}
    </MenuList>
  )
}

function ProshopCart({ sessionCart, open, setOpen, goToPay }) {
  const { t } = useTranslation()
  return (
    <Drawer anchor='right' open={sessionCart.length > 0 && open} onClose={() => setOpen(false)}>
      <Grid container direction='column' justifyContent='flex-start' alignItems='flex-start' style={{ width: 300, padding: 20 }}>
        <Typography variant='h6'>{t('cart')}</Typography><IconButton onClick={() => setOpen(false)} style={{ position: 'absolute', right: 0, top: 0 }}>X</IconButton>
        {/* { IMG, COUNT, NAME, PRICE } */}
        {sessionCart.map((p, i) => (
          <div key={i} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10, marginBottom: 10 }}>
          <Grid item style={{ marginTop: 10, marginBottom: 10 }}>
            {p.poster ? <img src={p.poster.url} alt={p.displayName} style={{ width: 50, height: 50 }} /> : null}
            </Grid>
            <Grid item style={{ marginLeft: 10 }}>
              <Typography variant='caption'>
                {p.count} x {p.displayName} - {(p.selectedVariant ? p.selectedVariant.name + ' '  : '')}
              </Typography>
            </Grid>
            <Grid item style={{ marginLeft: 10 }}>
              <Typography variant='caption' style={{ fontWeight: 'bold' }}>
                {(p.selectedVariant ? (p.selectedVariant.price * p.count / 100).toFixed(2).replace('.', ',') + ' €' : '')}
              </Typography>
            </Grid>
          </div>
        ))}
      </Grid>
      <Grid container direction='column' justifyContent='flex-end' alignItems='flex-end' style={{ width: 300, padding: 20 }}>
        <Typography variant='caption' style={{ textAlign: 'right'}}>{t('includes_tax_excludes_shipping')}</Typography>
      </Grid>
      <Grid container direction='column' justifyContent='flex-start' alignItems='flex-end' style={{ width: 300, padding: 20 }}>
        <Typography variant='h6'>{t('total')}: {(sessionCart.reduce((acc, p) => acc + (p.selectedVariant ? p.selectedVariant.price * p.count : 0), 0) / 100).toFixed(2).replace('.', ',')} €</Typography>
      </Grid>
      <Button variant='contained' color='primary' style={{ margin: 20 }} onClick={goToPay}>{t('checkout')}</Button>
      <Typography variant='caption' style={{ marginTop: 0, marginLeft: 20, marginRight: 20, textAlign: 'right' }}>{t('you_can_edit_quantity_in_cart')}</Typography>
    </Drawer>
  )
}

function ProshopScreen({ appconfig, products, categories, brands }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const hasProducts = products && products.length > 0
  const [selectedCategory, setSelectedCategory] = React.useState(null)
  const [selectedProduct, setSelectedProduct] = React.useState(null)
  // rehydrate the cart from redux if the user came back after an auth-wall detour
  const payableCart = useSelector(({ payable: { selected } }) =>
    Array.isArray(selected) && selected.length > 0 && selected.every((i) => i.collection === 'proshop')
      ? selected
      : null
  )
  const [sessionCart, setSessionCart] = React.useState(payableCart || [])
  const [cartOpen, setCartOpen] = React.useState(false)


  const onSelectCategory = (categoryId) => {
    setSelectedCategory(categoryId)
    setSelectedProduct(null)
  }

  const addToCart = (product, count) => {
    const updatedProduct = { ...product, count }
    // if cart already has this product with same variant, update count
    const existingProduct = sessionCart.find((p) => p.id === updatedProduct.id && p.selectedVariant?.varid === updatedProduct.selectedVariant?.varid)
    if (existingProduct) {
      existingProduct.count += updatedProduct.count
      setSessionCart([...sessionCart.filter((p) => p !== existingProduct), existingProduct])
      setCartOpen(true)
    } else {
      setSessionCart([...sessionCart, updatedProduct])
      setCartOpen(true)
    }
  }

  const goToPay = () => {
      dispatch({
        type: 'UPDATE_PAYABLE_PROSHOP',
        payload: sessionCart,
      })
      history.push(appconfig.pathPrefix + '/proshop/checkout')
  }

  if (!hasProducts) {
    return (
      <div className='full-page-background'>
        <TopNavigation />
        <Container className='front' style={{ paddingTop: 10 }}>
          <Typography variant='h6' style={{ paddingBottom: 20 }}>
            {t('products')} (0)
          </Typography>
          <Typography variant='body1'>{t('noproducts')}</Typography>
        </Container>
      </div>
    )
  }

  return (
    <div className='full-page-background'>
      <TopNavigation />
      <Container className='front' style={{ paddingTop: 10 }}>
        <ProshopCart sessionCart={sessionCart} open={cartOpen} setOpen={setCartOpen} goToPay={goToPay} />
    <Row>
      <Col>
        <CategoryFilter
          categories={categories}
          selectedCategory={selectedCategory}
          onSelectCategory={onSelectCategory}
          numberofproducts={products && products.length ? products.length : 0}
          />
          </Col>
          <Col>
          {/* Cart here */}
            {sessionCart.length > 0 ? (
              <Typography variant='body1'>
                {t('cart')}: {sessionCart.length} {t('items')}
              </Typography>) : null}
          </Col>
          </Row>
        <Row>
          {selectedProduct ? (
            <Col xs={12}>
              <ProShopProductCard
                product={selectedProduct}
                collection={'proshop/products'}
                isAuthRequired={false}
                onSelected={setSelectedProduct}
                selected={true}
                onCart={addToCart}
              />
            </Col>
          ) : null}
            {!selectedProduct && products.filter((m) => !selectedCategory || m.productcategory === selectedCategory).map((m) => (
              <Col key={m.id} xs={12} sm={4}>
                <ProShopProductCard
                  product={m}
                  collection={'proshop/products'}
                  isAuthRequired={false}
                  onSelected={setSelectedProduct}
                  selected={selectedProduct && selectedProduct.id === m.id}
                />
              </Col>
            ))}
        </Row>
        {/* <Row>
          <Col xs={12}>
            {sessionCart.length > 0 ? sessionCart.map((p, i) => (
              <React.Fragment key={i}>
              <Typography key={i} variant='body1'>
                {p.displayName} - {(p.selectedVariant ? p.selectedVariant.name + ' ' + (p.selectedVariant.price / 100).toFixed(2).replace('.', ',') + ' €' : '')}
              </Typography>
              <pre>{JSON.stringify(p, null, 2)}</pre>
            </React.Fragment>
            )) : null}
          </Col>
        </Row> */}
      </Container>
    </div>
  )
}

export default withAppconfig(withProducts(ProshopScreen))
